// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"styles_minHeight__3_rGL","placeholderAnchor":"styles_placeholderAnchor__2lQ7F","placeholder":"styles_placeholder__3O3uy","spaceUnder":"styles_spaceUnder__3VZ_r"};